import * as ApiManager from './_manager';
import store from '@/store';

export const screenerAccessLink = {

  generateMagicLink: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/generateMagicLink`,
      payload
    );
  },

  getPreviewLink: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/getPreviewLink`,
      payload
    );
  },

  getMagicLink: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/getMagicLink`,
      payload
    );
  },

  markMagicLinkPaused: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/markMagicLinkPaused`,
      payload
    );
  },

  activateMagicLink: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/activateMagicLink`,
      payload
    );
  },

  markMagicLinkExpired: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/markMagicLinkExpired`,
      payload
    );
  },

  deleteMagicLink: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/deleteMagicLink`,
      payload
    );
  },

  generateNewMagicLink: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/generateNewMagicLink`,
      payload
    );
  },

  generateUploadLink: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/` +
        payload.film_id +
        `/generateUploadLink`,
      payload
    );
  },

  getUploadLink: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/` +
        payload.film_id +
        `/getUploadLink`,
      payload
    );
  },

  deleteUploadLink: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/` +
        payload.film_id +
        `/deleteUploadLink`,
      payload
    );
  },

};
